/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_EmptyInputs */

const cs_social_templates_empty = /** @type {(inputs: Social_Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné šablony — výchozí se vytvoří při prvním použití.`)
};

const en_social_templates_empty = /** @type {(inputs: Social_Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates yet — defaults are seeded on first use.`)
};

/**
* | output |
* | --- |
* | "No templates yet — defaults are seeded on first use." |
*
* @param {Social_Templates_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_empty = /** @type {((inputs?: Social_Templates_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_empty(inputs)
	return cs_social_templates_empty(inputs)
});